import { NgModule } from '@angular/core'
import { ScrollToElementOnNavigationDirective } from './scroll-to-element-on-navigation.directive'

@NgModule({
  declarations: [ScrollToElementOnNavigationDirective],
  exports: [ScrollToElementOnNavigationDirective]
})
export class ScrollToElementOnNavigationModule {}
